export default (state) => {
  state.currentAdministrator.fundersReport.items = [];
  state.currentAdministrator.fundersReport.isFetching = true;
  state.currentAdministrator.fundersReport.totalCount = null;
};
